<template>
  <div
    :class="[
      $style.base,
      { [$style.isSmall]: $screen === 's' || $screen === 'm' }
    ]"
  >
    <div :class="$style.inner">
      <BaseHeading v-if="$screen === 'l'">
        {{ $t('products.your_order') }}
      </BaseHeading>
      <BaseAlert
        v-if="hasDeletedItems && !selectedProducts.length"
        color="error"
        :text="$t('products.deleted_products_fill')"
      />
      <div
        v-if="selectedProducts && selectedProducts.length"
        :class="$style.table"
      >
        <BaseTableRow head>
          <BaseTableCell :width="35">{{ $t('global.name') }}</BaseTableCell>
          <BaseTableCell :width="30">{{ $t('global.amount') }}</BaseTableCell>
          <BaseTableCell :width="25">{{ $t('global.price') }}</BaseTableCell>
          <BaseTableCell :width="25">{{ $t('global.total') }}</BaseTableCell>
          <BaseTableCell
            right
            :width="5"
          />
        </BaseTableRow>
        <OrderRow
          v-for="product in selectedProducts"
          :key="product.productId"
          :product="product"
          @updateSelectedProduct="$emit('updateSelectedProduct', $event)"
          @deleteSelectedProduct="$emit('deleteSelectedProduct', $event)"
          v-test="'selectedProducts'"
        />
      </div>
      <EmptyOrder
        v-else
        :supplier="supplier"
        @addSelectedProducts="$emit('addSelectedProducts', $event)"
      />
      <OrderActions
        :selectedProducts="selectedProducts"
        :deletedProducts="deletedProducts"
      />
    </div>
  </div>
</template>

<script
  lang="ts"
  setup
>
import BaseTableCell from '@/components/_deprecated/BaseTableCell.vue';
import BaseTableRow from '@/components/_deprecated/BaseTableRow.vue';
import type { Supplier } from '@/types';
import EmptyOrder from './EmptyOrder.vue';
import OrderActions from './OrderActions.vue';
import OrderRow from './OrderRow.vue';
import type { SelectedProduct } from './types';

withDefaults(
  defineProps<{
    selectedProducts: SelectedProduct[];
    deletedProducts: SelectedProduct[];
    hasDeletedItems: boolean;
    supplier: Supplier;
  }>(),
  {
    hasDeletedItems: false,
  },
);

defineEmits([
  'addSelectedProducts',
  'updateSelectedProduct',
  'deleteSelectedProduct',
]);
</script>

<style
  lang="scss"
  module
>
.base {
  width: 50%;
  height: 100%;
  position: relative;

  &.isSmall {
    width: 100%;
  }
}

.inner {
  overflow: auto;
  padding: $spacing;
  height: calc(100% - 75px);
}

.table {
  min-width: 440px;

  .isSmall & {
    margin-bottom: $spacing * 2;
  }
}
</style>
